module.exports = __webpack_public_path__ + "img/article_ad_banner_04.d4e878a5.jpg";